module.exports = __webpack_public_path__ + "img/t+pazolite.79b7ecea.jpg";